export const supportedAggregationExportFormats = [
  { id: "pdf", title: "PDF" },
  { id: "csv", title: "CSV" },
  { id: "json", title: "JSON" },
  { id: "yaml", title: "YAML" },
  { id: "xml", title: "XML" },
  { id: "xlsx", title: "XLSX" }
];
export const supportedEventsOverviewExportFormats = [
  { id: "csv", title: "CSV" },
  { id: "json", title: "JSON" }
];
